<div *ngIf="!containsError">
  <div *ngIf="successMess">
    <app-service-transfer-loan-select [loanNumbers]="loanDetailsArray" [servicerNumber]="newServicerNumber"
      [effectiveDate]="effectiveDate" [oldServicerNumber]="oldServicerNumber" [portFolioInd]="partialIndicatorType"
      (loanSubmitClick)="loanSubmitCall($event)"></app-service-transfer-loan-select>
  </div>
  <div class="success-msg" *ngIf="loanSuccess">
    <li>{{validateMsg}}</li><br>
    <li>{{loanSuccessMsg}}</li>
  </div>

  <div class="success-msg" *ngIf="noLoanData">
    No Loan Data returned for your servicer transfer transaction.
  </div>

  <div>
    <div class="errorMessage " *ngIf="errorMessage.length">
      {{errHeading}}
      <li *ngFor="let message of errorMessage">{{message}}</li>
      <hr class="hrStyle">
    </div>
  </div>
  <div *ngIf="!successMess">
    <div class="notesMess">
      1. Type in the Old Servicer Number. 2. Type in the New Servicer Number. 3. Type in the effective date. 4. Pick a
      Source from the list. 4. Click on Submit to get all loans for the Old Servicer. 5. Click on Clear to clear all the
      fields.
    </div>
    <div class="indicates">
      <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
        required information</span>
    </div>
    <br>
    <span class="adminTblAlign">
      <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Old Servicer Number: </div>
      <div class="ui-g-2" *ngIf="!isExternal"> <input type="text" maxlength="9" [(ngModel)]='oldServicerNumber'
          maxlength="9" (keyup)="trackKeyPress($event)" autofocus fmTextInput></div>
      <div class="ui-g-2" *ngIf="isExternal">
        <fm-select [options]="serNumber" ariaLabelledBy="default" [(ngModel)]='oldServicerNumber'></fm-select>

      </div>
    </span>
    <span class="adminTblAlign">
      <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>New Servicer Number: </div>
      <div class="ui-g-2"> <input type="text" [(ngModel)]='newServicerNumber' maxlength="9"
          (keyup)="trackKeyPress($event)" fmTextInput></div>
    </span>
    <span class="adminTblAlign">
      <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Effective Date: </div>
      <div class="ui-g-3">
        <fm-calendar id="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="&nbsp;&nbsp;MM/DD/YYYY"
          [(ngModel)]='effectiveDate' [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')"
          (keyup)="trackKeyPress($event)" [showClear]="true"></fm-calendar>
      </div>
    </span>
    <span class="adminTblAlign">
      <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label> Source: </div>
      <div class="ui-g-2">
        <fm-select [options]="partialIndicatorArray" [(ngModel)]="partialIndicatorType" ariaLabelledBy="default">
        </fm-select>
      </div>
    </span>
    <div class="btnAlign">
      <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()"
        class="dispbuttonMargin"></button>

      <button fmButton type="button" [small]="true" [primary]="true" label="Submit" (click)="serviceTransferSubmit()"
        class="dispbuttonMargin"></button>
    </div>


  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>